import { QueryObserverOptions } from "@tanstack/react-query"

import { Duration } from "@shared/types/duration"
import { AllergyResponse } from "@shared/zod/schemas/responses/allergy"

import { axiosPatient } from "./generic/AxiosInterceptor/AxiosInterceptor"

// Sets defaults used in `buildApiFromServices`.
// Avoid refetching too often. The medical files do not change that often
export const queryOptions: Partial<QueryObserverOptions> = {
  staleTime: Duration.from("30 minutes").milliseconds,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchInterval: false,
}

export const getAll = async (): Promise<AllergyResponse[]> => {
  const resp = await axiosPatient({
    url: "/patient/allergies",
    method: "get",
  })
  return resp.data
}
